import { Tag, TagLabel, TagCloseButton, Wrap } from '@chakra-ui/react';

interface FilterOption {
  id: string;
  label: string;
}

interface FilterTagsProps {
  filters: {
    courses?: string[];
    assessorIds?: string[];
    providerIds?: string[];
    contractIds?: string[];
    outcome?: string | undefined;
  };
  coursesOptions?: FilterOption[];
  assessorsOptions?: FilterOption[];
  outcomeOptions?: FilterOption[];
  providerOptions?: FilterOption[];
  contractOptions?: FilterOption[];
  onRemoveFilter: (filterKey: string, valueId: string) => void;
}

export function FilterTags({
  filters,
  coursesOptions,
  assessorsOptions,
  outcomeOptions,
  providerOptions,
  contractOptions,
  onRemoveFilter,
}: FilterTagsProps) {
  const activeFilterTags: Array<{
    id: string;
    label: string;
    filterKey: string;
    type: string;
  }> = [];

  // Assessors
  if (filters.assessorIds != null && filters.assessorIds.length > 0) {
    const selectedAssessorIds = filters.assessorIds;
    selectedAssessorIds.forEach((id) => {
      const assessor = assessorsOptions?.find((a) => a.id === id);
      if (assessor != null) {
        activeFilterTags.push({
          id,
          label: assessor.label,
          filterKey: 'assessorIds',
          type: 'Assessor',
        });
      }
    });
  }

  // Courses
  if (filters.courses != null && filters.courses.length > 0) {
    const selectedCourseIds = filters.courses;
    selectedCourseIds.forEach((id) => {
      const course = coursesOptions?.find((c) => c.id === id);
      if (course != null) {
        activeFilterTags.push({
          id,
          label: course.label,
          filterKey: 'courses',
          type: 'Course',
        });
      }
    });
  }

  // Providers
  if (filters.providerIds != null && filters.providerIds.length > 0) {
    const selectedProviderIds = filters.providerIds;
    selectedProviderIds.forEach((id) => {
      const provider = providerOptions?.find((p) => p.id === id);
      if (provider != null) {
        activeFilterTags.push({
          id,
          label: provider.label,
          filterKey: 'providerIds',
          type: 'Provider',
        });
      }
    });
  }

  // Contracts
  if (filters.contractIds != null && filters.contractIds.length > 0) {
    const selectedContractIds = filters.contractIds;
    selectedContractIds.forEach((id) => {
      const contract = contractOptions?.find((c) => c.id === id);
      if (contract != null) {
        activeFilterTags.push({
          id,
          label: contract.label,
          filterKey: 'contractIds',
          type: 'Contract',
        });
      }
    });
  }

  // Outcome
  if (filters.outcome != null) {
    const outcome = outcomeOptions?.find((o) => o.id === filters.outcome);
    if (outcome != null) {
      activeFilterTags.push({
        id: filters.outcome,
        label: outcome.label,
        filterKey: 'outcome',
        type: 'Outcome',
      });
    }
  }

  if (activeFilterTags.length === 0) {
    return null;
  }

  return (
    <Wrap spacing={2} mb={4}>
      {activeFilterTags.map((tag) => (
        <Tag key={`${tag.filterKey}-${tag.id}`} size="md" variant="subtle" colorScheme="gray">
          <TagLabel>
            {tag.type}: {tag.label}
          </TagLabel>
          <TagCloseButton onClick={() => onRemoveFilter(tag.filterKey, tag.id)} />
        </Tag>
      ))}
    </Wrap>
  );
}
